export const customerRelationshipOptions = {
    label: {
        isBillTo: "Is a bill-to customer",
        isShipTo: "Is a ship-to customer",
        isNotBillTo: "Is not a bill-to customer",
        isNotShipTo: "Is not a ship-to customer",
    },
    value: {
        isBillTo: "billTo",
        isShipTo: "shipTo",
        isNotBillTo: "notBillTo",
        isNotShipTo: "notShipTo",
    },
};

export const customerExposuresOptions = {
    label: {
        missingCertificates: "Missing certificates",
        invalidCertificates: "Invalid certificates",
        expiredCertificates: "Expired certificates",
    },
    value: {
        missingCertificates: "EXPOSURE: MISSING CERT",
        invalidCertificates: "EXPOSURE: INVALID CERT",
        expiredCertificates: "EXPOSURE: EXPIRED CERT",
    },
};

export function getCustomerRelationShip(relationShip, key) {
    const oppositeKey =
        key === customerRelationshipOptions.value.isBillTo
            ? customerRelationshipOptions.value.isNotBillTo
            : customerRelationshipOptions.value.isNotShipTo;

    // If both positive and negative relationships exist, return null
    if (relationShip.includes(key) && relationShip.includes(oppositeKey)) {
        return null;
    }

    // Return true if key exists, false if opposite exists, null if neither exists
    return relationShip.includes(key) ? true : relationShip.includes(oppositeKey) ? false : null;
}
